// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-StatusIndicator-module__StatusIndicator";
var _2 = "webpack-concepts-Extraction-StudyList-StatusIndicator-module__complete webpack-concepts-Extraction-StudyList-StatusIndicator-module__StatusIndicator";
var _3 = "webpack-concepts-Extraction-StudyList-StatusIndicator-module__draft webpack-concepts-Extraction-StudyList-StatusIndicator-module__StatusIndicator";
export { _1 as "StatusIndicator", _2 as "complete", _3 as "draft" }
